//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import util from '@/lib/util';
import {formatDate} from '../../../src/lib/date';

export default {
    name: "active",
    components: {
        BottomNav,
    },
    filters: {
        // formatDate(time, type) {
        //     var date = new Date(time);
        //     if (type == 1) {
        //         return formatDate(date, 'yyyy/MM/dd');
        //     }
        //     return formatDate(date, 'yyyy-MM-dd hh:mm');
        // }
    },
    data() {
        return {
            activeList: [],
            hotActive: [],
            images: [
                require('@/assets/img/banner-index1.jpg'),
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg'
            ],
            list: [],
            pageIndex: 1,
            pageSize: 10,
            refreshing: false,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + 'file/download/',
            member: {}
        };
    },
    methods: {
        onLoad() {
            console.log('onLoad')
            this.pageIndex++;
            this.getActiveList();
        },
        onRefresh() {
            console.log('onRefresh')
            this.pageIndex = 1;
            this.getActiveList();
        },
        getActiveList() {
            const vm = this;
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex >= 1;
            let page = {
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize,
                memberId: abp.session.userId,
                memberLevel: this.member.memberLevel,
            };
            abp.ajax.post('/api/services/app/Activity/Search', page).then((res) => {
                if (vm.pageIndex === 1) {
                    this.list = [];
                }
                vm.list.push(...res.data.result.items);
                if (res.data.result.items.length < vm.pageSize) {
                    vm.finished = true;
                } else {
                    vm.finished = false;
                }
            }).finally(() => {
                vm.refreshing = false;
                vm.loading = false;
            });

        },
        goToDetail(id) {
            // this.$router.push({
            //     path: '/activeDetail/'+id,
            // });
            this.$router.push('/activeDetail/' + id);
            // this.$router.push({name:'activeDetail',params:{id:id}});
        },
        async getMyMember() {
            const vm = this;
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = {};
                vm.member = vm.$store.state.member.memberInfo;
                vm.onRefresh();
            });
        },
    },
    created() {
        this.loading = true;
        this.getMyMember();
        // this.onRefresh();
    }
}
